window.CalorieFoodDatabase = [
  /* Meyveler */
  {n:"Elma",k:52,p:0.3,c:14,f:0.2},
  {n:"Armut",k:57,p:0.4,c:15,f:0.1},
  {n:"Muz",k:89,p:1.1,c:23,f:0.3},
  {n:"Portakal",k:47,p:0.9,c:12,f:0.1},
  {n:"Mandalina",k:53,p:0.8,c:13,f:0.3},
  {n:"Greyfurt",k:42,p:0.8,c:11,f:0.1},
  {n:"Limon",k:29,p:1.1,c:9,f:0.3},
  {n:"Çilek",k:32,p:0.7,c:8,f:0.3},
  {n:"Kiraz",k:63,p:1.1,c:16,f:0.2},
  {n:"Vişne",k:50,p:1.0,c:12,f:0.3},
  {n:"Kayısı",k:48,p:1.4,c:11,f:0.4},
  {n:"Şeftali",k:39,p:0.9,c:10,f:0.3},
  {n:"Nektarin",k:44,p:1.1,c:11,f:0.3},
  {n:"Erik",k:46,p:0.7,c:11,f:0.3},
  {n:"Üzüm",k:69,p:0.7,c:18,f:0.2},
  {n:"Karpuz",k:30,p:0.6,c:8,f:0.2},
  {n:"Kavun",k:34,p:0.8,c:8,f:0.2},
  {n:"İncir",k:74,p:0.8,c:19,f:0.3},
  {n:"Nar",k:83,p:1.7,c:19,f:1.2},
  {n:"Ayva",k:57,p:0.4,c:15,f:0.1},
  {n:"Kivi",k:61,p:1.1,c:15,f:0.5},
  {n:"Ananas",k:50,p:0.5,c:13,f:0.1},
  {n:"Mango",k:60,p:0.8,c:15,f:0.4},
  {n:"Avokado",k:160,p:2.0,c:9,f:15},
  {n:"Hurma",k:282,p:2.5,c:75,f:0.4},
  {n:"Kuru Üzüm",k:299,p:3.1,c:79,f:0.5},
  {n:"Kuru Kayısı",k:241,p:3.4,c:63,f:0.5},
  {n:"Kuru İncir",k:249,p:3.3,c:64,f:1.0},
  /* Sebzeler */
  {n:"Domates",k:18,p:0.9,c:3.9,f:0.2},
  {n:"Salatalık",k:15,p:0.7,c:3.6,f:0.1},
  {n:"Marul",k:15,p:1.4,c:2.9,f:0.2},
  {n:"Ispanak",k:23,p:2.9,c:3.6,f:0.4},
  {n:"Brokoli",k:34,p:2.8,c:7,f:0.4},
  {n:"Karnabahar",k:25,p:1.9,c:5,f:0.3},
  {n:"Havuç",k:41,p:0.9,c:10,f:0.2},
  {n:"Patates",k:77,p:2.0,c:17,f:0.1},
  {n:"Patlıcan",k:25,p:1.0,c:6,f:0.2},
  {n:"Kabak",k:17,p:1.2,c:3.1,f:0.3},
  {n:"Biber (Yeşil)",k:20,p:0.9,c:4.6,f:0.2},
  {n:"Biber (Kırmızı)",k:31,p:1.0,c:6,f:0.3},
  {n:"Soğan",k:40,p:1.1,c:9,f:0.1},
  {n:"Sarımsak",k:149,p:6.4,c:33,f:0.5},
  {n:"Pırasa",k:61,p:1.5,c:14,f:0.3},
  {n:"Kereviz",k:16,p:0.7,c:3,f:0.2},
  {n:"Lahana",k:25,p:1.3,c:6,f:0.1},
  {n:"Brüksel Lahanası",k:43,p:3.4,c:9,f:0.3},
  {n:"Bezelye",k:81,p:5.4,c:14,f:0.4},
  {n:"Fasulye (Taze)",k:31,p:1.8,c:7,f:0.2},
  {n:"Bamya",k:33,p:2.0,c:7,f:0.2},
  {n:"Mantar",k:22,p:3.1,c:3.3,f:0.3},
  {n:"Turp",k:16,p:0.7,c:3.4,f:0.1},
  {n:"Pancar",k:43,p:1.6,c:10,f:0.2},
  {n:"Enginar",k:47,p:3.3,c:11,f:0.2},
  {n:"Semizotu",k:20,p:2.0,c:3.4,f:0.4},
  {n:"Roka",k:25,p:2.6,c:3.7,f:0.7},
  {n:"Maydanoz",k:36,p:3.0,c:6,f:0.8},
  {n:"Dereotu",k:43,p:3.5,c:7,f:1.1},
  {n:"Nane",k:70,p:3.8,c:15,f:0.9},
  /* Et ve Tavuk */
  {n:"Dana Eti (Yağsız)",k:135,p:26,c:0,f:3},
  {n:"Dana Biftek",k:250,p:26,c:0,f:15},
  {n:"Kuzu Eti",k:294,p:25,c:0,f:21},
  {n:"Kıyma (Dana)",k:250,p:26,c:0,f:15},
  {n:"Köfte (Kızartma)",k:280,p:18,c:8,f:20},
  {n:"Köfte (Izgara)",k:220,p:20,c:5,f:14},
  {n:"Tavuk Göğsü (Haşlama)",k:165,p:31,c:0,f:3.6},
  {n:"Tavuk Göğsü (Izgara)",k:175,p:30,c:0,f:5},
  {n:"Tavuk But (Derili)",k:209,p:26,c:0,f:11},
  {n:"Hindi Göğsü",k:135,p:30,c:0,f:1},
  {n:"Sucuk",k:455,p:24,c:2,f:38},
  {n:"Pastırma",k:250,p:30,c:1,f:13},
  {n:"Salam",k:336,p:13,c:3,f:30},
  {n:"Sosis",k:301,p:12,c:2,f:27},
  {n:"Jambon",k:145,p:21,c:1,f:6},
  {n:"Ciğer (Dana)",k:135,p:20,c:4,f:4},
  {n:"Et Sote",k:195,p:22,c:5,f:10},
  {n:"Kavurma",k:320,p:28,c:2,f:22},
  {n:"Döner Et (Tavuk)",k:190,p:22,c:3,f:9},
  {n:"Döner Et (Et)",k:240,p:20,c:4,f:15},
  /* Balık ve Deniz Ürünleri */
  {n:"Levrek",k:97,p:18,c:0,f:2},
  {n:"Çipura",k:96,p:18,c:0,f:2},
  {n:"Somon",k:208,p:20,c:0,f:13},
  {n:"Ton Balığı (Konserve)",k:116,p:26,c:0,f:1},
  {n:"Hamsi",k:131,p:20,c:0,f:5},
  {n:"Sardalya",k:208,p:25,c:0,f:11},
  {n:"Uskumru",k:205,p:19,c:0,f:14},
  {n:"Palamut",k:139,p:20,c:0,f:6},
  {n:"Alabalık",k:119,p:20,c:0,f:3.5},
  {n:"Karides",k:99,p:24,c:0,f:0.3},
  {n:"Kalamar",k:92,p:16,c:3,f:1.4},
  {n:"Midye",k:86,p:12,c:4,f:2},
  {n:"Balık Izgara",k:150,p:22,c:0,f:6},
  {n:"Balık Tava",k:220,p:18,c:10,f:12},
  {n:"Balık Buğulama",k:130,p:20,c:2,f:4},
  /* Süt Ürünleri */
  {n:"Süt (Tam Yağlı)",k:61,p:3.2,c:4.8,f:3.3},
  {n:"Süt (Yarım Yağlı)",k:50,p:3.4,c:5,f:1.8},
  {n:"Süt (Yağsız)",k:34,p:3.4,c:5,f:0.1},
  {n:"Yoğurt (Tam Yağlı)",k:61,p:3.5,c:4.7,f:3.3},
  {n:"Yoğurt (Light)",k:56,p:4.3,c:7,f:1.5},
  {n:"Ayran",k:37,p:2.0,c:3.5,f:1.5},
  {n:"Kefir",k:64,p:3.3,c:4.5,f:3.5},
  {n:"Beyaz Peynir",k:264,p:17,c:2,f:21},
  {n:"Kaşar Peyniri",k:374,p:25,c:2,f:30},
  {n:"Lor Peyniri",k:98,p:11,c:3,f:4},
  {n:"Labne",k:180,p:8,c:4,f:15},
  {n:"Krem Peynir",k:342,p:6,c:4,f:34},
  {n:"Tereyağı",k:717,p:0.9,c:0.1,f:81},
  {n:"Margarin",k:717,p:0.2,c:0.7,f:81},
  {n:"Kaymak",k:431,p:2,c:3,f:45},
  {n:"Krema (Sıvı)",k:345,p:2,c:3,f:37},
  /* Tahıllar ve Ekmek */
  {n:"Beyaz Ekmek",k:265,p:9,c:49,f:3.2},
  {n:"Tam Buğday Ekmeği",k:247,p:13,c:41,f:3.4},
  {n:"Çavdar Ekmeği",k:259,p:8,c:48,f:3.3},
  {n:"Simit",k:275,p:8,c:52,f:4},
  {n:"Pide",k:275,p:8,c:52,f:4},
  {n:"Lavaş",k:260,p:8,c:50,f:3},
  {n:"Bazlama",k:280,p:8,c:52,f:5},
  {n:"Galeta Unu",k:371,p:13,c:72,f:4},
  {n:"Bulgur (Pişmiş)",k:83,p:3,c:19,f:0.2},
  {n:"Pirinç (Pişmiş)",k:130,p:2.7,c:28,f:0.3},
  {n:"Makarna (Pişmiş)",k:131,p:5,c:25,f:1.1},
  {n:"Yulaf Ezmesi",k:389,p:17,c:66,f:7},
  {n:"Mısır Unu",k:370,p:7,c:79,f:4},
  {n:"Un (Beyaz)",k:364,p:10,c:76,f:1},
  {n:"Kuskus (Pişmiş)",k:112,p:3.8,c:23,f:0.2},
  /* Çorbalar */
  {n:"Mercimek Çorbası",k:75,p:4,c:12,f:1.5},
  {n:"Ezogelin Çorbası",k:80,p:3,c:13,f:2},
  {n:"Tarhana Çorbası",k:85,p:3,c:12,f:2.5},
  {n:"Domates Çorbası",k:55,p:2,c:8,f:1.5},
  {n:"İşkembe Çorbası",k:65,p:5,c:5,f:3},
  {n:"Düğün Çorbası",k:90,p:4,c:10,f:4},
  {n:"Yayla Çorbası",k:70,p:3,c:9,f:2.5},
  {n:"Sebze Çorbası",k:45,p:2,c:7,f:1},
  {n:"Tavuk Çorbası",k:50,p:4,c:5,f:1.5},
  {n:"Balık Çorbası",k:60,p:5,c:6,f:2},
  {n:"Kelle Paça Çorbası",k:95,p:8,c:3,f:6},
  {n:"Mantar Çorbası",k:55,p:2,c:7,f:2},
  /* Kebaplar ve Et Yemekleri */
  {n:"Adana Kebap",k:280,p:22,c:3,f:20},
  {n:"Urfa Kebap",k:260,p:22,c:2,f:18},
  {n:"Şiş Kebap",k:240,p:24,c:2,f:15},
  {n:"İskender Kebap",k:220,p:18,c:15,f:12},
  {n:"Beyti Kebap",k:290,p:20,c:12,f:20},
  {n:"Ali Nazik",k:210,p:16,c:10,f:12},
  {n:"Tantuni",k:195,p:18,c:8,f:10},
  {n:"Çiğ Köfte",k:150,p:5,c:25,f:4},
  {n:"Lahmacun",k:230,p:10,c:28,f:9},
  {n:"Pide (Etli)",k:280,p:14,c:32,f:12},
  {n:"Pide (Kaşarlı)",k:300,p:12,c:35,f:14},
  {n:"Karnıyarık",k:120,p:6,c:8,f:8},
  {n:"Musakka",k:130,p:7,c:10,f:8},
  {n:"Hünkar Beğendi",k:180,p:12,c:10,f:11},
  {n:"Etli Güveç",k:140,p:14,c:8,f:6},
  {n:"Tas Kebabı",k:160,p:18,c:6,f:7},
  {n:"Sulu Köfte",k:110,p:10,c:8,f:4},
  {n:"İzmir Köfte",k:150,p:14,c:10,f:7},
  {n:"Patlıcan Kebabı",k:130,p:8,c:10,f:7},
  /* Pilav ve Makarna Yemekleri */
  {n:"Pilav (Sade)",k:130,p:2.7,c:28,f:0.3},
  {n:"Pilav (Tereyağlı)",k:170,p:3,c:28,f:5},
  {n:"Nohutlu Pilav",k:150,p:5,c:26,f:3},
  {n:"Etli Pilav",k:180,p:10,c:24,f:5},
  {n:"Mantı",k:220,p:10,c:28,f:8},
  {n:"Spagetti Bolonez",k:140,p:7,c:18,f:4},
  {n:"Lazanya",k:180,p:10,c:18,f:8},
  {n:"Erişte",k:140,p:5,c:26,f:2},
  {n:"Makarna Salatası",k:160,p:5,c:22,f:6},
  /* Baklagiller */
  {n:"Nohut (Pişmiş)",k:164,p:9,c:27,f:2.6},
  {n:"Mercimek (Pişmiş)",k:116,p:9,c:20,f:0.4},
  {n:"Kuru Fasulye (Pişmiş)",k:127,p:9,c:23,f:0.5},
  {n:"Barbunya (Pişmiş)",k:127,p:9,c:23,f:0.5},
  {n:"Börülce (Pişmiş)",k:116,p:8,c:21,f:0.5},
  {n:"Falafel",k:333,p:13,c:32,f:18},
  {n:"Humus",k:166,p:8,c:14,f:10},
  /* Zeytinyağlılar ve Mezeler */
  {n:"Zeytinyağlı Fasulye",k:110,p:4,c:12,f:5},
  {n:"Zeytinyağlı Barbunya",k:110,p:4,c:12,f:5},
  {n:"Zeytinyağlı Enginar",k:90,p:3,c:8,f:5},
  {n:"Zeytinyağlı Bamya",k:85,p:3,c:8,f:4},
  {n:"Dolma (Yaprak)",k:120,p:3,c:15,f:5},
  {n:"Dolma (Biber)",k:110,p:4,c:12,f:5},
  {n:"Sarma (Yaprak)",k:115,p:3,c:14,f:5},
  {n:"Imam Bayıldı",k:130,p:2,c:10,f:10},
  {n:"Karnıyarık (Zeytinyağlı)",k:100,p:2,c:8,f:7},
  {n:"Piyaz",k:130,p:6,c:18,f:4},
  {n:"Cacık",k:55,p:3,c:4,f:3},
  {n:"Haydari",k:120,p:5,c:4,f:10},
  {n:"Ezme",k:80,p:2,c:8,f:4},
  {n:"Acılı Ezme",k:85,p:2,c:9,f:4},
  {n:"Patlıcan Salatası",k:90,p:2,c:8,f:5},
  {n:"Çoban Salata",k:45,p:1.5,c:6,f:2},
  {n:"Mevsim Salata",k:35,p:1.5,c:5,f:1.5},
  {n:"Roka Salatası",k:50,p:2,c:5,f:3},
  {n:"Ton Balıklı Salata",k:120,p:12,c:6,f:6},
  {n:"Tavuk Salata",k:130,p:14,c:5,f:6},
  /* Börek ve Hamur İşleri */
  {n:"Börek (Peynirli)",k:280,p:10,c:28,f:14},
  {n:"Börek (Kıymalı)",k:300,p:12,c:26,f:16},
  {n:"Su Böreği",k:260,p:9,c:30,f:12},
  {n:"Sigara Böreği",k:320,p:8,c:28,f:18},
  {n:"Gözleme (Peynirli)",k:250,p:9,c:32,f:9},
  {n:"Gözleme (Ispanaklı)",k:220,p:8,c:30,f:7},
  {n:"Mantı (Fırın)",k:230,p:11,c:30,f:8},
  {n:"Poğaça",k:350,p:8,c:42,f:16},
  {n:"Açma",k:380,p:8,c:45,f:18},
  {n:"Kurabiye",k:450,p:6,c:60,f:20},
  /* Kahvaltı */
  {n:"Yumurta (Haşlanmış)",k:155,p:13,c:1.1,f:11},
  {n:"Yumurta (Sahanda)",k:196,p:14,c:1,f:15},
  {n:"Menemen",k:120,p:7,c:5,f:8},
  {n:"Sucuklu Yumurta",k:220,p:14,c:2,f:17},
  {n:"Omlet",k:154,p:11,c:1,f:12},
  {n:"Sahanda Yumurta",k:196,p:14,c:1,f:15},
  {n:"Reçel",k:278,p:0.4,c:70,f:0.1},
  {n:"Bal",k:304,p:0.3,c:82,f:0},
  {n:"Tahin",k:595,p:17,c:21,f:54},
  {n:"Pekmez",k:290,p:1,c:72,f:0.2},
  {n:"Zeytin (Siyah)",k:115,p:0.8,c:6,f:11},
  {n:"Zeytin (Yeşil)",k:145,p:1,c:4,f:15},
  {n:"Sucuklu Pide",k:310,p:14,c:32,f:15},
  {n:"Kuymak",k:250,p:8,c:22,f:14},
  {n:"Muhlama",k:250,p:8,c:22,f:14},
  /* Fast Food */
  {n:"Hamburger",k:295,p:17,c:30,f:12},
  {n:"Cheeseburger",k:320,p:18,c:28,f:16},
  {n:"Tavuk Burger",k:280,p:18,c:28,f:11},
  {n:"Patates Kızartması",k:312,p:3.4,c:41,f:15},
  {n:"Soğan Halkası",k:411,p:5,c:44,f:23},
  {n:"Pizza (Margarita)",k:250,p:10,c:30,f:10},
  {n:"Pizza (Karışık)",k:280,p:12,c:28,f:13},
  {n:"Tost (Kaşarlı)",k:320,p:14,c:32,f:15},
  {n:"Tost (Karışık)",k:340,p:16,c:30,f:17},
  {n:"Sandviç (Tavuk)",k:250,p:18,c:28,f:8},
  {n:"Wrap (Tavuk)",k:240,p:16,c:28,f:9},
  {n:"Hot Dog",k:290,p:10,c:24,f:17},
  {n:"Nugget",k:296,p:14,c:18,f:18},
  {n:"Tavuk Kanat (Kızartma)",k:290,p:22,c:8,f:19},
  {n:"Çıtır Tavuk",k:280,p:20,c:15,f:16},
  {n:"Kumpir",k:180,p:4,c:32,f:4},
  {n:"Midye Tava",k:220,p:12,c:18,f:12},
  {n:"Kokoreç",k:250,p:18,c:5,f:18},
  {n:"Kumru",k:320,p:12,c:35,f:15},
  /* Tatlılar */
  {n:"Baklava",k:430,p:5,c:55,f:22},
  {n:"Künefe",k:380,p:8,c:45,f:18},
  {n:"Kadayıf",k:400,p:6,c:52,f:20},
  {n:"Sütlaç",k:120,p:4,c:20,f:3},
  {n:"Kazandibi",k:180,p:5,c:25,f:7},
  {n:"Muhallebi",k:130,p:4,c:22,f:3},
  {n:"Keşkül",k:150,p:5,c:22,f:5},
  {n:"Revani",k:320,p:5,c:50,f:12},
  {n:"Şekerpare",k:400,p:5,c:55,f:18},
  {n:"Lokum",k:350,p:0.2,c:85,f:0.5},
  {n:"Helva",k:520,p:12,c:55,f:30},
  {n:"Tahin Helvası",k:480,p:12,c:50,f:28},
  {n:"Aşure",k:150,p:3,c:30,f:2},
  {n:"Güllaç",k:140,p:3,c:28,f:2},
  {n:"Profiterol",k:350,p:5,c:35,f:20},
  {n:"Magnolia",k:280,p:4,c:32,f:14},
  {n:"Cheesecake",k:320,p:6,c:30,f:20},
  {n:"Tiramisu",k:340,p:5,c:38,f:18},
  {n:"Dondurma",k:207,p:3.5,c:24,f:11},
  {n:"Waffle",k:310,p:6,c:42,f:13},
  {n:"Krep",k:227,p:6,c:28,f:10},
  {n:"Pancake",k:227,p:6,c:28,f:10},
  {n:"Kurabiye (Tereyağlı)",k:480,p:6,c:58,f:24},
  {n:"Muffin",k:380,p:5,c:52,f:17},
  {n:"Brownie",k:410,p:5,c:50,f:22},
  {n:"Çikolata",k:535,p:5,c:60,f:30},
  {n:"Sütlü Çikolata",k:530,p:7,c:58,f:30},
  /* Kuruyemiş ve Tohumlar */
  {n:"Badem",k:579,p:21,c:22,f:50},
  {n:"Ceviz",k:654,p:15,c:14,f:65},
  {n:"Fındık",k:628,p:15,c:17,f:61},
  {n:"Fıstık",k:567,p:26,c:16,f:49},
  {n:"Antep Fıstığı",k:560,p:20,c:28,f:45},
  {n:"Kaju",k:553,p:18,c:30,f:44},
  {n:"Ay Çekirdeği",k:584,p:21,c:20,f:51},
  {n:"Kabak Çekirdeği",k:559,p:30,c:11,f:49},
  {n:"Susam",k:573,p:18,c:23,f:50},
  {n:"Çekirdek (Karışık)",k:570,p:20,c:18,f:48},
  {n:"Kuru Yemiş Karışımı",k:580,p:18,c:20,f:48},
  /* İçecekler */
  {n:"Su",k:0,p:0,c:0,f:0},
  {n:"Çay (Şekersiz)",k:1,p:0,c:0.3,f:0},
  {n:"Çay (Şekerli)",k:30,p:0,c:7,f:0},
  {n:"Türk Kahvesi",k:2,p:0.1,c:0,f:0},
  {n:"Nescafe (Sütlü)",k:45,p:2,c:5,f:2},
  {n:"Espresso",k:2,p:0.1,c:0,f:0},
  {n:"Latte",k:60,p:3,c:6,f:3},
  {n:"Cappuccino",k:50,p:3,c:5,f:2.5},
  {n:"Portakal Suyu",k:45,p:0.7,c:10,f:0.2},
  {n:"Elma Suyu",k:46,p:0.1,c:11,f:0.1},
  {n:"Ayran (Hazır)",k:37,p:2,c:3.5,f:1.5},
  {n:"Kola",k:42,p:0,c:11,f:0},
  {n:"Fanta",k:45,p:0,c:11,f:0},
  {n:"Gazoz",k:40,p:0,c:10,f:0},
  {n:"Şalgam Suyu",k:20,p:0.5,c:4,f:0},
  {n:"Boza",k:70,p:1.5,c:15,f:0.5},
  {n:"Sahlep",k:80,p:2,c:15,f:1},
  {n:"Smoothie (Meyveli)",k:65,p:1.5,c:14,f:0.5},
  {n:"Protein Shake",k:120,p:25,c:3,f:2},
  {n:"Bira",k:43,p:0.5,c:3.6,f:0},
  {n:"Şarap (Kırmızı)",k:85,p:0.1,c:2.6,f:0},
  {n:"Rakı",k:295,p:0,c:0,f:0},
  /* Atıştırmalıklar ve Diğer */
  {n:"Cips",k:536,p:7,c:53,f:34},
  {n:"Patlamış Mısır",k:387,p:13,c:78,f:5},
  {n:"Kraker",k:420,p:9,c:68,f:12},
  {n:"Bisküvi",k:450,p:6,c:68,f:18},
  {n:"Granola Bar",k:420,p:8,c:55,f:18},
  {n:"Protein Bar",k:350,p:20,c:35,f:12},
  {n:"Mısır Gevreği",k:380,p:7,c:84,f:1},
  {n:"Müsli",k:350,p:10,c:60,f:8},
  {n:"Tahin Pekmez",k:450,p:9,c:50,f:22},
  {n:"Pilav Üstü Tavuk",k:175,p:20,c:20,f:5},
  {n:"Tavuk Döner Dürüm",k:250,p:18,c:28,f:9},
  {n:"Et Döner Dürüm",k:280,p:16,c:26,f:12},
  {n:"Falafel Dürüm",k:280,p:10,c:35,f:12},
  {n:"Adana Dürüm",k:290,p:20,c:28,f:14},
  {n:"Çiğ Börek",k:250,p:10,c:30,f:10},
  {n:"Puf Böreği",k:300,p:7,c:35,f:15},
  {n:"Kısır",k:150,p:4,c:25,f:4},
  {n:"Bulgur Salatası",k:150,p:4,c:25,f:4},
  {n:"Turşu",k:15,p:0.5,c:3,f:0.1},
  {n:"Ketçap",k:112,p:1.7,c:27,f:0.1},
  {n:"Mayonez",k:680,p:1,c:1,f:75},
  {n:"Hardal",k:66,p:4,c:5,f:4},
  {n:"Zeytinyağı",k:884,p:0,c:0,f:100},
  {n:"Ayçiçek Yağı",k:884,p:0,c:0,f:100},
  {n:"Tereyağlı Pirinç",k:150,p:3,c:28,f:3},
  {n:"Kısır (Narlı)",k:155,p:4,c:26,f:4.5},
  {n:"İskilip Dolması",k:130,p:5,c:15,f:5},
  {n:"Hamsili Pilav",k:160,p:8,c:24,f:4},
  {n:"Mücver",k:140,p:6,c:10,f:9},
  {n:"Kabak Mücver",k:140,p:6,c:10,f:9},
  {n:"Kumpir (Tam)",k:200,p:5,c:35,f:5},
  {n:"Köri Tavuk",k:180,p:18,c:8,f:8},
  {n:"Tavuk Sote",k:165,p:22,c:5,f:6},
  {n:"Et Sote (Sebzeli)",k:175,p:20,c:8,f:7},
  {n:"Güveç",k:130,p:12,c:10,f:5},
  {n:"Türlü",k:90,p:3,c:10,f:4},
  {n:"Ratatuy",k:85,p:2,c:10,f:4},
  {n:"Fırın Sebze",k:80,p:2,c:12,f:3},
  {n:"Izgara Sebze",k:70,p:2,c:10,f:2.5},
  {n:"Humus (Ev Yapımı)",k:166,p:8,c:14,f:10},
  {n:"Mercimek Köftesi",k:180,p:8,c:28,f:4},
  {n:"Pirinç Pilavı",k:130,p:2.7,c:28,f:0.3},
  {n:"Bulgur Pilavı",k:83,p:3,c:19,f:0.2},
  {n:"Nohut Yemeği",k:140,p:8,c:18,f:4},
  {n:"Kuru Fasulye Yemeği",k:130,p:8,c:18,f:3},
  {n:"Ispanak Yemeği",k:80,p:4,c:8,f:4},
  {n:"Pırasa Yemeği",k:90,p:3,c:10,f:4},
  {n:"Kabak Yemeği",k:75,p:2,c:10,f:3},
  {n:"Bamya Yemeği",k:85,p:3,c:10,f:3},
  {n:"Taze Fasulye Yemeği",k:80,p:3,c:10,f:3},
  {n:"Patates Yemeği",k:100,p:2,c:15,f:3},
  {n:"Havuç Tarator",k:120,p:3,c:8,f:9},
  {n:"Cacık (Yoğurtlu)",k:55,p:3,c:4,f:3},
  {n:"Yoğurtlu Patates Salatası",k:130,p:4,c:15,f:6},
  {n:"Rus Salatası",k:180,p:3,c:12,f:14},
  {n:"Coleslaw",k:120,p:1.5,c:10,f:8},
  {n:"Tavuk Şiş",k:180,p:25,c:2,f:8},
  {n:"Kuzu Şiş",k:250,p:24,c:1,f:17},
  {n:"Adana Döner",k:280,p:22,c:3,f:20},
  {n:"İskender (Porsiyon)",k:350,p:22,c:25,f:18},
  {n:"Pide (Sucuklu)",k:320,p:14,c:34,f:15},
  {n:"Pide (Kıymalı)",k:290,p:15,c:32,f:12},
  {n:"Pide (Karışık)",k:310,p:14,c:33,f:14},
  {n:"Lahmacun (İnce)",k:220,p:10,c:26,f:8},
  {n:"Pideli Köfte",k:240,p:18,c:22,f:10},
  {n:"Çorba (Genel)",k:70,p:3,c:10,f:2},
  {n:"Omlet (Peynirli)",k:180,p:13,c:2,f:14},
  {n:"Menemen (Sucuklu)",k:200,p:12,c:6,f:14},
  {n:"Simit (Peynirli)",k:320,p:12,c:48,f:10},
  {n:"Poğaça (Peynirli)",k:370,p:10,c:42,f:18},
  {n:"Açma (Zeytinli)",k:360,p:8,c:44,f:16},
  {n:"Kruvasan",k:406,p:8,c:45,f:21},
  {n:"Ekler",k:350,p:5,c:35,f:20},
  {n:"Supangle",k:280,p:4,c:38,f:12},
  {n:"Trileçe",k:320,p:5,c:40,f:16},
  {n:"Tres Leches",k:320,p:5,c:40,f:16},
  {n:"Mozaik Pasta",k:380,p:5,c:48,f:20},
  {n:"Pasta (Kremalı)",k:350,p:5,c:45,f:16},
  {n:"Pasta (Çikolatalı)",k:380,p:5,c:48,f:20},
  {n:"Sakız",k:360,p:0,c:90,f:0},
  {n:"Şeker",k:387,p:0,c:100,f:0},
  {n:"Tuz",k:0,p:0,c:0,f:0},
  {n:"Sirke",k:18,p:0,c:0.9,f:0},
  {n:"Salça (Domates)",k:82,p:4,c:18,f:0.5},
  {n:"Salça (Biber)",k:90,p:3,c:18,f:1},
  {n:"Nar Ekşisi",k:120,p:0.5,c:28,f:0.2},
  {n:"Sumak",k:331,p:6,c:71,f:8},
  {n:"Kimyon",k:375,p:18,c:44,f:22},
  {n:"Kırmızı Biber (Toz)",k:318,p:12,c:56,f:17},
  {n:"Karabiber",k:251,p:10,c:64,f:3},
  {n:"Tahinli Susam",k:580,p:18,c:22,f:50},
  {n:"Lokma",k:380,p:5,c:50,f:18},
  {n:"Höşmerim",k:280,p:10,c:25,f:16},
  {n:"Süt Helvası",k:350,p:6,c:50,f:14},
  {n:"İrmik Helvası",k:380,p:5,c:55,f:16},
  {n:"Un Helvası",k:400,p:5,c:55,f:18},
  {n:"Kabak Tatlısı",k:150,p:1,c:35,f:0.3},
  {n:"Ayva Tatlısı",k:180,p:0.5,c:42,f:0.2},
  {n:"İncir Tatlısı",k:170,p:1,c:40,f:0.3},
  {n:"Vişne Kompostosu",k:120,p:0.5,c:30,f:0.2},
  {n:"Komposto",k:110,p:0.5,c:28,f:0.2},
  {n:"Hoşaf",k:110,p:0.5,c:28,f:0.2},
  {n:"Meyve Salatası",k:55,p:0.8,c:14,f:0.3},
  {n:"Meyve Tabakı",k:60,p:1,c:15,f:0.4},
  {n:"Smoothie Bowl",k:90,p:3,c:16,f:2},
  {n:"Granola",k:400,p:10,c:55,f:15},
  {n:"Chia Tohumu",k:486,p:17,c:42,f:31},
  {n:"Kinoa (Pişmiş)",k:120,p:4,c:21,f:2},
  {n:"Amarant",k:371,p:14,c:65,f:7},
  {n:"Spirulina",k:290,p:57,c:24,f:8},
  {n:"Propolis",k:300,p:5,c:60,f:2},
  {n:"Arı Sütü",k:150,p:12,c:15,f:5},
  {n:"Polen",k:320,p:20,c:45,f:5},
  {n:"Bitki Çayı",k:1,p:0,c:0.2,f:0},
  {n:"Ihlamur Çayı",k:1,p:0,c:0.2,f:0},
  {n:"Adaçayı Çayı",k:1,p:0,c:0.2,f:0},
  {n:"Papatya Çayı",k:1,p:0,c:0.2,f:0},
  {n:"Yeşil Çay",k:1,p:0,c:0,f:0},
  {n:"Matcha Latte",k:55,p:3,c:6,f:2},
  {n:"Bubble Tea",k:120,p:1,c:28,f:2},
  {n:"Milkshake",k:150,p:4,c:22,f:5},
  {n:"Frappuccino",k:180,p:3,c:30,f:5},
  {n:"Ice Tea",k:35,p:0,c:9,f:0},
  {n:"Limonata",k:40,p:0.2,c:10,f:0.1},
  {n:"Ayran (Ev Yapımı)",k:37,p:2,c:3.5,f:1.5},
  {n:"Şalgam",k:20,p:0.5,c:4,f:0},
  {n:"Turna Yemişi Suyu",k:46,p:0.3,c:11,f:0.1},
  {n:"Vişne Suyu",k:50,p:0.5,c:12,f:0.2},
  {n:"Kayısı Suyu",k:48,p:0.5,c:11,f:0.2},
  {n:"Nar Suyu",k:54,p:0.3,c:13,f:0.2},
  {n:"Smoothie (Yeşil)",k:45,p:2,c:8,f:1},
  {n:"Detox Suyu",k:30,p:0.5,c:6,f:0.2},
  {n:"Kefir Smoothie",k:70,p:4,c:10,f:2},
  {n:"Yoğurt Smoothie",k:75,p:4,c:11,f:2},
  {n:"Protein Yoğurt",k:80,p:10,c:6,f:2},
  {n:"Skyr",k:63,p:11,c:4,f:0.2},
  {n:"Greek Yoğurt",k:97,p:9,c:4,f:5},
  {n:"Cottage Cheese",k:98,p:11,c:3,f:4},
  {n:"Ricotta",k:174,p:11,c:3,f:13},
  {n:"Mozzarella",k:280,p:22,c:2,f:20},
  {n:"Parmesan",k:431,p:38,c:4,f:29},
  {n:"Dil Peyniri",k:290,p:22,c:2,f:22},
  {n:"Hellim Peyniri",k:321,p:22,c:2,f:25},
  {n:"Çökelek",k:98,p:11,c:3,f:4},
  {n:"Süzme Yoğurt",k:97,p:10,c:4,f:5},
  {n:"Probiyotik Yoğurt",k:65,p:4,c:5,f:3},
  {n:"Vegan Yoğurt",k:60,p:3,c:8,f:2},
  {n:"Badem Sütü",k:17,p:0.6,c:1.5,f:1.2},
  {n:"Soya Sütü",k:33,p:2,c:2,f:1.8},
  {n:"Yulaf Sütü",k:48,p:1,c:7,f:2},
  {n:"Hindistan Cevizi Sütü",k:230,p:2,c:6,f:24},
  {n:"Tofu",k:76,p:8,c:2,f:4.8},
  {n:"Tempeh",k:193,p:20,c:9,f:11},
  {n:"Seitan",k:120,p:25,c:4,f:2},
  {n:"Vegan Burger",k:220,p:15,c:20,f:10},
  {n:"Vegan Sosis",k:200,p:12,c:8,f:14},
  {n:"Mercimek Burger",k:180,p:10,c:22,f:6},
  {n:"Falafel (Kızartma)",k:333,p:13,c:32,f:18},
  {n:"Falafel (Fırın)",k:250,p:13,c:32,f:10},
  {n:"Humus (Tahinli)",k:180,p:8,c:14,f:12},
  {n:"Babaganuş",k:90,p:2,c:8,f:6},
  {n:"Muhammara",k:200,p:4,c:15,f:14},
  {n:"Tarator",k:120,p:3,c:8,f:9},
  {n:"Cevizli Tarator",k:150,p:5,c:8,f:12},
  {n:"Atom",k:100,p:2,c:8,f:7},
  {n:"Şakşuka",k:90,p:2,c:10,f:5},
  {n:"Köpoğlu",k:110,p:4,c:12,f:5},
  {n:"Fava",k:120,p:5,c:15,f:4},
  {n:"Bigos",k:130,p:8,c:10,f:7},
  {n:"Mantı (Ev Yapımı)",k:220,p:10,c:28,f:8},
  {n:"Erişte (Ev Yapımı)",k:140,p:5,c:26,f:2},
  {n:"Gnocchi",k:140,p:4,c:26,f:2},
  {n:"Ravioli",k:180,p:8,c:24,f:6},
  {n:"Tortellini",k:180,p:8,c:24,f:6},
  {n:"Cannelloni",k:170,p:9,c:22,f:6},
  {n:"Risotto",k:150,p:5,c:24,f:4},
  {n:"Paella",k:160,p:10,c:22,f:5},
  {n:"Noodle (Çin)",k:140,p:5,c:25,f:2},
  {n:"Ramen",k:150,p:8,c:20,f:5},
  {n:"Pho",k:90,p:6,c:12,f:2},
  {n:"Sushi",k:150,p:6,c:28,f:1},
  {n:"Sashimi",k:120,p:22,c:0,f:2},
  {n:"Tempura",k:250,p:8,c:25,f:12},
  {n:"Pad Thai",k:180,p:8,c:25,f:6},
  {n:"Curry (Tavuk)",k:180,p:18,c:8,f:8},
  {n:"Butter Chicken",k:200,p:16,c:8,f:12},
  {n:"Naan",k:260,p:8,c:45,f:4},
  {n:"Chapati",k:240,p:8,c:42,f:4},
  {n:"Burrito",k:250,p:12,c:30,f:10},
  {n:"Taco",k:220,p:10,c:22,f:10},
  {n:"Quesadilla",k:280,p:14,c:24,f:14},
  {n:"Nachos",k:350,p:8,c:35,f:20},
  {n:"Guacamole",k:160,p:2,c:9,f:15},
  {n:"Salsa",k:36,p:1.5,c:7,f:0.2},
  {n:"Tabbouleh",k:120,p:3,c:15,f:5},
  {n:"Fattoush",k:90,p:2,c:12,f:4},
  {n:"Shawarma",k:250,p:18,c:20,f:12},
  {n:"Falafel Wrap",k:280,p:10,c:35,f:12},
  {n:"Kebap (Dürüm)",k:270,p:18,c:26,f:12},
  {n:"Adana Wrap",k:290,p:20,c:28,f:14},
  {n:"Tavuk Şiş Dürüm",k:240,p:22,c:24,f:8},
  {n:"Et Şiş Dürüm",k:280,p:22,c:22,f:14},
  {n:"Falafel Tabağı",k:280,p:12,c:30,f:14},
  {n:"Meze Tabağı",k:150,p:5,c:12,f:10},
  {n:"Karışık Izgara",k:250,p:28,c:2,f:14},
  {n:"Izgara Köfte",k:220,p:20,c:5,f:14},
  {n:"Izgara Tavuk",k:175,p:30,c:0,f:5},
  {n:"Izgara Balık",k:150,p:22,c:0,f:6},
  {n:"Izgara Sebze Tabağı",k:70,p:2,c:10,f:2.5},
  /* Ek Salatalar */
  {n:"Sezar Salata",k:180,p:10,c:6,f:14},
  {n:"Akdeniz Salatası",k:120,p:3,c:8,f:9},
  {n:"Gavurdağı Salatası",k:90,p:3,c:8,f:6},
  {n:"Roka Nar Salatası",k:80,p:2,c:10,f:5},
  /* Bölgesel ve Geleneksel */
  {n:"Hamsi Tava",k:220,p:18,c:12,f:12},
  {n:"Hamsi Buğulama",k:140,p:20,c:2,f:5},
  {n:"Kelle Söğüş",k:180,p:18,c:2,f:12},
  {n:"Ayak Paça",k:120,p:15,c:2,f:7},
  {n:"İşkembe Tava",k:200,p:18,c:3,f:13},
  {n:"Ciğer Tava",k:210,p:22,c:4,f:12},
  {n:"Arnavut Ciğeri",k:220,p:20,c:5,f:14},
  {n:"Kokoreç (Porsiyon)",k:250,p:18,c:5,f:18},
  {n:"Beyran Çorbası",k:85,p:6,c:6,f:4},
  {n:"Paça Çorbası",k:95,p:8,c:3,f:6},
  {n:"Analı Kızlı",k:130,p:6,c:18,f:4},
  {n:"Kayseri Mantısı",k:230,p:11,c:30,f:8},
  {n:"Bursa İskender",k:350,p:22,c:25,f:18},
  {n:"Oruk",k:200,p:12,c:18,f:10},
  {n:"İçli Köfte",k:250,p:10,c:22,f:14},
  {n:"Kısır (Narlı)",k:155,p:4,c:26,f:4.5},
  {n:"Çiğ Börek",k:250,p:10,c:30,f:10},
  {n:"Katmer",k:420,p:8,c:50,f:22},
  {n:"Kaymaklı Ekmek Kadayıfı",k:410,p:6,c:52,f:20},
  {n:"Burma Kadayıf",k:400,p:6,c:50,f:20},
  {n:"Zerde",k:130,p:1,c:32,f:0.2},
  {n:"Aşure (Ev Yapımı)",k:150,p:3,c:30,f:2},
  {n:"Pelte",k:120,p:2,c:28,f:0.5},
  {n:"Süt Helvası (Fırın)",k:360,p:6,c:52,f:14},
  {n:"Pişmaniye",k:400,p:2,c:85,f:8},
  {n:"Lokum (Fıstıklı)",k:380,p:4,c:75,f:12},
  {n:"Cevizli Sucuk",k:450,p:8,c:55,f:22},
  {n:"Pestil",k:320,p:3,c:72,f:2},
  {n:"Köme",k:350,p:6,c:60,f:12},
  {n:"Gevrek",k:280,p:9,c:48,f:6},
  {n:"Simit (Tam Buğday)",k:260,p:9,c:48,f:4},
  {n:"Ekmek (Çavdar)",k:259,p:8,c:48,f:3.3},
  {n:"Ekmek (Glutensiz)",k:240,p:4,c:48,f:3},
  {n:"Yufka",k:290,p:8,c:58,f:2},
  {n:"Bazlama (Peynirli)",k:300,p:10,c:48,f:8},
  {n:"Lahmacun (Fırın)",k:220,p:10,c:26,f:8},
  {n:"Pideli Kaşar",k:300,p:12,c:35,f:14},
  {n:"Kumpir (Karışık)",k:220,p:6,c:35,f:6},
  {n:"Mısır",k:86,p:3.3,c:19,f:1.2},
  {n:"Bezelye (Konserve)",k:80,p:5,c:14,f:0.5},
  {n:"Mantar (Konserve)",k:25,p:2,c:4,f:0.3},
  {n:"Ton (Zeytinyağlı)",k:116,p:26,c:0,f:1},
  {n:"Sardalya (Konserve)",k:208,p:25,c:0,f:11},
  {n:"Havyar",k:264,p:25,c:4,f:18},
  {n:"Somon Füme",k:117,p:18,c:0,f:4},
  {n:"Tavuk Nugget (Fırın)",k:250,p:18,c:18,f:12},
  {n:"Tavuk Kanat (Fırın)",k:220,p:24,c:6,f:12},
  {n:"Tavuk Schnitzel",k:250,p:20,c:15,f:12},
  {n:"Schnitzel",k:260,p:18,c:16,f:14},
  {n:"Köfte (Fırın)",k:200,p:20,c:6,f:10},
  {n:"Köfte (Izgara)",k:220,p:20,c:5,f:14},
  {n:"İnegöl Köfte",k:230,p:20,c:6,f:14},
  {n:"Tekirdağ Köfte",k:240,p:21,c:5,f:15},
  {n:"Sulu Nohut",k:130,p:7,c:18,f:3},
  {n:"Etli Nohut",k:160,p:12,c:18,f:5},
  {n:"Kuru Fasulye (Etli)",k:140,p:10,c:18,f:4},
  {n:"Nohut Yemeği (Etli)",k:160,p:10,c:18,f:5},
  {n:"Bamya (Etli)",k:110,p:8,c:10,f:5},
  {n:"Ispanak (Etli)",k:100,p:8,c:8,f:5},
  {n:"Kabak (Kıymalı)",k:120,p:10,c:8,f:6},
  {n:"Patlıcan Musakka",k:130,p:7,c:10,f:8},
  {n:"Fırın Makarna",k:160,p:7,c:22,f:5},
  {n:"Fırın Sebze Graten",k:90,p:3,c:10,f:5},
  {n:"Graten",k:120,p:6,c:10,f:7},
  {n:"Omlet (Sebzeli)",k:140,p:10,c:4,f:10},
  {n:"Menemen (Peynirli)",k:140,p:9,c:6,f:10},
  {n:"Çılbır",k:150,p:10,c:3,f:11},
  {n:"Yumurta Sarısı",k:322,p:16,c:3.6,f:27},
  {n:"Yumurta Beyazı",k:52,p:11,c:0.7,f:0.2},
  {n:"Protein Tozu (Sütle)",k:120,p:25,c:3,f:2},
  {n:"Whey Protein",k:400,p:80,c:8,f:5},
  {n:"BCAA İçecek",k:5,p:0,c:0,f:0},
  {n:"Elektrolit İçecek",k:25,p:0,c:6,f:0},
  {n:"Spor İçeceği",k:30,p:0,c:7,f:0},
  {n:"Kefir (Light)",k:50,p:4,c:5,f:1},
  {n:"Ayran (Light)",k:30,p:2,c:3,f:0.5},
  {n:"Yoğurt (Süzme)",k:97,p:10,c:4,f:5},
  {n:"Yoğurt (Ev Yapımı)",k:61,p:3.5,c:4.7,f:3.3},
  {n:"Tulum Peyniri",k:350,p:20,c:2,f:28},
  {n:"Örgü Peyniri",k:300,p:20,c:3,f:24},
  {n:"Çeçil Peyniri",k:280,p:22,c:2,f:22},
  {n:"Ezine Peyniri",k:270,p:18,c:2,f:22},
  {n:"Van Otlu Peynir",k:290,p:18,c:2,f:24},
  {n:"Mihaliç Peyniri",k:320,p:22,c:2,f:26},
  {n:"Gravyer Peyniri",k:380,p:25,c:2,f:30}
];
